import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background,backdrop-filter,border-color] duration-500 ${
        scrolled
          ? "bg-background/70 backdrop-blur-xl border-b border-border"
          : "bg-transparent border-b border-transparent"
      }`}
      data-testid="main-nav"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img
            src="/salons-for-sale.png"
            alt="Salons For Sale"
            className="h-14 w-auto"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-10 eyebrow text-foreground/80">
          <a href="/#how" data-testid="nav-how" className="hover:text-brand transition-colors">
            How it works
          </a>
          <a href="/#about" data-testid="nav-about" className="hover:text-brand transition-colors">
            About Us
          </a>
        </nav>

        <button
          data-testid="nav-start-button"
          onClick={() => navigate("/valuation")}
          className="group inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-5 py-2.5 eyebrow hover:bg-brand transition-colors duration-300"
        >
          Start Valuation
          <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
            &rarr;
          </span>
        </button>
      </div>
    </motion.header>
  );
};
